import Steering from '../components/Committee/Steering'
export default function SteeringCommittee() {
    return(
        <main className='mt-28'>
        <Steering />
        </main>
    )
}